/**
 * description: 选择音频的弹出框
 * created by liu jinming
 * created on 2017.09.08
 */
"use strict";
angular.module('mailListServiceMoudle', ['mailListMoudle'])
    .factory('mailListService', ["$q", "$modal", "trsHttpService", "modalDialog", function($q, $modal, trsHttpService, modalDialog) {
        return {
            mailList: function(arr) {
                var deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./components/service/mailList/mailList_tpl.html",
                    windowClass: "mail-list",
                    backdrop: false,
                    controller: "mailListCtrl",
                    resolve: {
                        arr: function() {
                            return arr;
                        }
                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    deffer.resolve(result);
                }, function() {
                    deffer.reject("cancle");
                });
                return deffer.promise;
            }
        };
    }]);